import { Responsive, UIHeading1, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Title.css';

interface ITitleProps {
  children: string;
}

export const Title: React.FC<ITitleProps> = ({ children }) => {
  return (
    <div className={styles['title']}>
      <Responsive desktop tablet>
        <UIHeading1>{children}</UIHeading1>
      </Responsive>
      <Responsive phone>
        <UIHeading2>{children}</UIHeading2>
      </Responsive>
    </div>
  );
};
